import "./DefaultError.scss";

const DefaultError = ({ children, testId, dataCy }) => (
  <div className="DefaultError" data-testid={testId} data-cy={dataCy}>
    {children}
  </div>
);

export default DefaultError;
